var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buzz-circle",class:{ dark: _vm.dark, center: _vm.center },style:({
    top: _vm.top,
    bottom: _vm.bottom,
    left: _vm.left,
    right: _vm.right,
    width: _vm.size,
    height: _vm.size,
    zIndex: _vm.z,
    marginRight: _vm.marginRight,
    marginLeft: _vm.marginLeft,
    background: _vm.backgroundColor,
    color: _vm.textColor
  }),on:{"click":function($event){return _vm.toggleAnswer()}}},[(!_vm.decorative)?[(_vm.showAnswer)?_c('div',{staticClass:"text-box no-select answer",style:({fontSize: _vm.answerSize})},[_vm._v("\n      "+_vm._s(_vm.answer)+"\n      "),(_vm.units)?_c('div',{staticClass:"answer-units"},[_vm._v("\n        "+_vm._s(_vm.units)+"\n      ")]):_vm._e()]):_c('div',{staticClass:"text-box no-select question",style:({fontSize: _vm.questionSize})},[_vm._v("\n      "+_vm._s(_vm.question)+"\n    ")])]:_c('div',{staticClass:"text-box no-select",style:({fontSize: _vm.textSize})},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }